module.exports = __webpack_public_path__ + "static/media/Brazil.26449b12.svg";